import { AuxiliumComponent } from "../auxilium-component";

export class TextElement extends AuxiliumComponent {
	constructor() {
		super();

		this.variation = this.getAttribute("variation");
		this.size = this.getAttribute("size");
		this.weight = this.getAttribute("width");
		this.icon = this.getAttribute("icon");
		this.iconColour = this.getAttribute("icon-colour");
		this.iconSize = this.getAttribute("icon-size");
	}

	parsedCallback() {
		if (this.variation === "vrm") {
			const vrm = this.textContent.trim();

			if (vrm.length === 7 && !vrm.includes(" ")) {
				this.textContent = vrm.slice(0, 4) + " " + vrm.slice(4);
			}
		}

		if (this.icon) {
			const container = document.createElementWithContents("div", this.childNodes, {
				className: "h-align gap-sm"
			});

			container.prepend(document.createElementWithContents("chip-icon", null, {
				icon: this.icon,
				size: this.iconSize,
				colour: this.iconColour
			}));

			this.appendChild(container);
		}
	}
}
